import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.pulse.DOC}
  query SummitPulse($tenantId: ID!, $zoneId: ID!, $fromDate: AWSDate) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        pulse(fromDate: $fromDate) {
          ...FragmentSummitPulse
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SummitPulseQuery,
  ents.core.summit.Pulse | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select('pulse', fragments.pulse.TRANSFORMER),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SummitPulseQuery,
  ents.core.summit.Pulse | undefined,
  graphql.schema.SummitPulseQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
